'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { CircularProgressImage } from '@insta-club/components/common';
import { PlansResponse, SubscriptionPlan } from '@insta-club/models';
import { useSessionStore } from '@insta-club/state';
import { cn, formatDate } from '@insta-club/utilities';
import useSWR from 'swr';
import ReservedPlanItem from '../ReservedPlanItem';
import BuySubscriptionBanner from './buy-subscription';

export default function SubscriptionList() {
    const activePageId = useSessionStore((state) => state.activePageId);
    const { data: subscriptions, isLoading } = useSWR<PlansResponse>(
        activePageId ? ApiKeys.GET_ACTIVE_PLAN_SUBSCRIPTION(Number(activePageId).toString()) : null,
        (url: string) => fetcher(url, 'dashboard', 'GET')
    );

    const data: SubscriptionPlan[] = subscriptions?.data ?? [];
    const activeSubscription: SubscriptionPlan | null = data.find((item) => item.active === 1) ?? null;
    const reservedSubscription: SubscriptionPlan[] = data.filter((item) => item.active === 0);

    return (
        <>
            {isLoading ? (
                <div className='shadow-card animate-pulse rounded-xl bg-white'>
                    <div className='p-4'>
                        <div className='mb-6 flex items-center justify-between'>
                            <div className='h-4 w-40 rounded-md bg-gray-200' />
                            <div className='h-5 w-10 rounded-sm bg-gray-200' />
                        </div>
                        <div className='mb-3 h-[5px] w-full rounded-md bg-gray-200' />
                        <div className='h-3 w-48 rounded-md bg-gray-200' />
                    </div>
                    <div className='space-y-2 p-4'>
                        <div className='mb-6 flex items-center justify-between'>
                            <div className='h-4 w-36 rounded-md bg-gray-200' />
                            <div className='h-5 w-12 rounded-sm bg-gray-200' />
                        </div>
                        <div className='h-3 w-64 rounded-md bg-gray-200' />
                        <div className='flex justify-end'>
                            <div className='h-8 w-28 rounded-md bg-gray-200' />
                        </div>
                    </div>
                </div>
            ) : (
                <div className='space-y-3 py-4'>
                    {!activeSubscription && !reservedSubscription.length && <BuySubscriptionBanner />}
                    {activeSubscription || reservedSubscription.length ? (
                        <h4 className='text-base font-semibold text-gray-700'>اشتراک ویژه :</h4>
                    ) : null}

                    <div className={cn({ '': reservedSubscription.length })}>
                        <ActiveSubscriptionItem item={activeSubscription} reserved={reservedSubscription.length > 0} />
                    </div>
                    {reservedSubscription.map((item: SubscriptionPlan, index: number) => {
                        return (
                            <div key={`${item.plan.name}-${index}`}>
                                <ReservedPlanItem
                                    item={item}
                                    active={activeSubscription !== null}
                                    first={index == 0}
                                    last={index == reservedSubscription.length - 1}
                                />
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
}

function ActiveSubscriptionItem({ item }: { item: SubscriptionPlan | null; reserved: boolean }) {
    if (!item) return null;
    console.log(item, 'suv item');
    return (
        <div>
            <div className={cn('shadow-card bg-white p-4', 'rounded-2xl')}>
                <div className='flex items-center gap-2'>
                    <CircularProgressImage
                        src={item.plan.plan_type.image ?? '/icons/apple-touch-icon.png'}
                        alt='plan'
                        progress={((item.days - item.days_lefted) / item.days) * 100}
                        size={34}
                        strokeColor='#4D4DA7'
                    />
                    <div className='flex flex-1 items-start justify-between'>
                        <div className='flex flex-col items-start gap-1.5'>
                            <span className='text-sm font-bold text-gray-900'>
                                {item?.plan.plan_type.name + ' ' + item?.plan.name}
                                {/* {t('subscription', item?.plan.plan_type.name + ' ' + item?.plan.name)} */}
                            </span>
                            <div className='flex items-center justify-end space-x-1 text-xs font-normal text-gray-500'>
                                <span>پایان اعتبار :</span>
                                <span className='font-medium text-gray-600'>{`${item && formatDate(item.ended_at, '%d %m %y')}`}</span>
                            </div>
                        </div>

                        <span className='relative flex size-3'>
                            <span className='bg-success-400 absolute inline-flex h-full w-full animate-ping rounded-full opacity-75'></span>
                            <span className='bg-success-500 relative inline-flex size-3 rounded-full'></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

